module.exports = __webpack_public_path__ + "static/media/page-404.5b8cacaa.png";